<template>
  <div class="hello">

    <b-container>
        <b-row>
            <b-col>
                <h4>Create Invoice</h4>
            </b-col>
        </b-row>
    </b-container>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'

export default {    
    props: {
    },

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser'])
    },

    components: {
    },

    data() {
        return {

        }
    },

    methods:{
        pageChanged(){
            window.scrollTo(0,0)
        },
    },

    mounted(){
    },
}
</script>

